
import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  name: "InputCurrency",
  computed: {
    displayValue: {
      get: function() {
        if ((this as any).isInputActive) {
          return (this as any).value.toString();
        } else {
          if ((this as any).value) {
            if (typeof (this as any).value == "number") {
              return (this as any).toString().replace(/^[+-]?\d+/, function(int) {
                return int.replace(/(\d)(?=(\d{3})+$)/g, '$1.');
              });
            } else {
              return (this as any).value;
            }
          } else {
            return "0.00";
          }
        }
      },
      set: function(modifiedValue) {
        let newValue = parseFloat(modifiedValue.replace(/[^\d.-]/g, ""));
        if (isNaN(newValue)) {
          newValue = 0;
        }
        (this as any).newValue = newValue;
      }
    }
  }
})
export default class InputCurrency extends Vue {
  @Prop([String, Number]) value!: any;
  newValue: any = 0;
  isInputActive: boolean = false;

  emitValue() {
    this.$emit("checkChanges", this.newValue);
  }
}
